import { render, staticRenderFns } from "./passengers.vue?vue&type=template&id=36ac4a28&scoped=true&"
import script from "./passengers.vue?vue&type=script&lang=js&"
export * from "./passengers.vue?vue&type=script&lang=js&"
import style0 from "./passengers.vue?vue&type=style&index=0&id=36ac4a28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac4a28",
  null
  
)

export default component.exports